export const tinhTuoi = (ngaySinh: Date) => {
    const ngayHienTai = new Date();

    let tuoi = ngayHienTai.getFullYear() - ngaySinh.getFullYear();
    let thang = ngayHienTai.getMonth() - ngaySinh.getMonth();

    // Điều chỉnh nếu tháng hiện tại nhỏ hơn tháng sinh
    if (thang < 0) {
        tuoi--;
        thang += 12;
    }

    return `${tuoi} tuổi ${thang} tháng`;
}

export const formatThangTuoi = (soThang: number): string => {
    if (!soThang || soThang <= 0) return '-';
    const tuoi = Math.floor(soThang / 12);
    const thang = soThang % 12;
    if (tuoi === 0) return `${thang} tháng`;
    if (thang === 0) return `${tuoi} tuổi`;
    return `${tuoi} tuổi ${thang} tháng`;
}
